import type { ImageTypes } from "~enums/imageTypes";
import type { Image } from "~types/image";

export const findImageByTypes = (images: Image[] | undefined, imageTypes: ImageTypes[]): Image | undefined => {
  if (!images || images.length === 0) {
    return undefined;
  }

  const imageType = imageTypes.find((type) => images.some((image) => image.imageType === type));

  const image = images.find((image) => image.imageType === imageType);
  return image ? image : undefined;
};
